import { AbstractModelFactory } from "@projectstorm/react-canvas-core";
import CustomPortModel from "./CustomPortModel";

export default class CustomPortFactory extends AbstractModelFactory {
  constructor() {
    super("custom-port");
  }

  generateModel(data) {
    return new CustomPortModel();
  }
}
